// extracted by mini-css-extract-plugin
export default {"countdown":"Fba-z","srOnly":"Gba-z"};